import { FEATURE_FLAGS, useBooleanFlag } from "@src/services/feature-flags/feature-flags";
import { DownloadWorkbookButton } from "./DownloadWorkbookButton";
import { ExportMenu, type ExportMenuProps } from "./ExportMenu";

/** The site report's export control: the Export menu behind `roadsense_export`, else the download button. */
export function ReportExportAction(props: ExportMenuProps) {
  const exportMenuEnabled = useBooleanFlag(FEATURE_FLAGS.ROADSENSE_EXPORT);
  return exportMenuEnabled ? <ExportMenu {...props} /> : <DownloadWorkbookButton {...props} />;
}
